// extracted by mini-css-extract-plugin
export default {"base":"ViewSubscription_base__8pemI","detailsFlex":"ViewSubscription_detailsFlex__Cpr2+","details":"ViewSubscription_details__U5Y-W","cell":"ViewSubscription_cell__cvMtc"};